const PROBE_ORIGIN = 'https://origin.invalid'

// Browsers treat "\" as "/", and the URL parser silently strips tab/CR/LF,
// so either can turn "/\evil.com" or "/\t/evil.com" into "//evil.com".
// "%5C" is rejected too in case the value gets decoded a second time.
// eslint-disable-next-line no-control-regex
const UNSAFE_CHARS = /[\\\u0000-\u001f\u007f]|%5c/i

/**
 * Safe internal redirect path from ?next= query param.
 * Returns '/' for anything that is not a same-origin path.
 */
export function safeLoginNextPath(raw: string | null | undefined): string {
  if (!raw) return '/'
  if (!raw.startsWith('/') || raw.startsWith('//')) return '/'
  if (UNSAFE_CHARS.test(raw)) return '/'
  try {
    if (new URL(raw, PROBE_ORIGIN).origin !== PROBE_ORIGIN) return '/'
  } catch {
    return '/'
  }
  return raw
}
